import React from 'react';
import { Helmet } from 'react-helmet-async';

const BrandStyles: React.FC = () => {
  return (
    <Helmet>
      <style type="text/css">{`
        :root {
          --brand-charcoal-gray: #2E2E2E;
          --brand-trophy-gold: #CBA135;
          --brand-safety-orange: #FA6400;
          --brand-pure-white: #ffffff;
          --brand-black: #000000;
        }
        
        .text-brand-charcoal-gray { color: var(--brand-charcoal-gray); }
        .text-brand-trophy-gold { color: var(--brand-trophy-gold); }
        .text-brand-safety-orange { color: var(--brand-safety-orange); }
        .text-brand-pure-white { color: var(--brand-pure-white); }
        .text-brand-black { color: var(--brand-black); }
        
        .bg-brand-charcoal-gray { background-color: var(--brand-charcoal-gray); }
        .bg-brand-trophy-gold { background-color: var(--brand-trophy-gold); }
        .bg-brand-safety-orange { background-color: var(--brand-safety-orange); }
        .bg-brand-pure-white { background-color: var(--brand-pure-white); }
        .bg-brand-black { background-color: var(--brand-black); }
        
        .border-brand-charcoal-gray { border-color: var(--brand-charcoal-gray); }
        .border-brand-trophy-gold { border-color: var(--brand-trophy-gold); }
        .border-brand-safety-orange { border-color: var(--brand-safety-orange); }
        
        .hover\\:bg-brand-charcoal-gray:hover { background-color: var(--brand-charcoal-gray); }
        .hover\\:bg-brand-trophy-gold:hover { background-color: var(--brand-trophy-gold); }
        .hover\\:bg-brand-safety-orange:hover { background-color: var(--brand-safety-orange); }
        
        .hover\\:bg-brand-charcoal-gray\\/10:hover { background-color: rgba(46, 46, 46, 0.1); }
        .hover\\:bg-brand-trophy-gold\\/10:hover { background-color: rgba(203, 161, 53, 0.1); }
        .hover\\:bg-brand-safety-orange\\/90:hover { background-color: rgba(250, 100, 0, 0.9); }
        .hover\\:bg-brand-trophy-gold\\/90:hover { background-color: rgba(203, 161, 53, 0.9); }
        
        .bg-brand-charcoal-gray\\/10 { background-color: rgba(46, 46, 46, 0.1); }
        .bg-brand-trophy-gold\\/10 { background-color: rgba(203, 161, 53, 0.1); }
        .bg-brand-safety-orange\\/5 { background-color: rgba(250, 100, 0, 0.05); }
        .bg-brand-trophy-gold\\/5 { background-color: rgba(203, 161, 53, 0.05); }
        
        .hover\\:text-brand-charcoal-gray:hover { color: var(--brand-charcoal-gray); }
        .hover\\:text-brand-trophy-gold:hover { color: var(--brand-trophy-gold); }
        .hover\\:text-brand-safety-orange:hover { color: var(--brand-safety-orange); }

        .border-brand-charcoal-gray\\/30 { border-color: rgba(46, 46, 46, 0.3); }
        .border-brand-trophy-gold\\/30 { border-color: rgba(203, 161, 53, 0.3); }
        .border-brand-safety-orange\\/30 { border-color: rgba(250, 100, 0, 0.3); }
        .border-brand-trophy-gold\\/20 { border-color: rgba(203, 161, 53, 0.2); }

        /* SkyQuote container styling */
        #SkyQuoteEmbedContainer, #SkyQuoteContactFormContainer {
          min-height: 400px;
          width: 100%;
          background-color: #ffffff;
          border-radius: 0.5rem;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          padding: 1rem;
        }
        
        /* Contact form specific styling */
        .sky-quote-contact-form {
          width: 100%;
          min-height: 400px;
        }
      `}</style>
    </Helmet>
  );
};

export default BrandStyles;